import styled from 'styled-components';
import Colors from '../../constants/Colors';

const PortfolioPane = styled.div`
  display: grid;
  grid-gap: 2px;
  grid-template-rows: 50px 60px auto;
  width: 320px;
  height: 100%;
  background: ${Colors.deepBlack};
`;

const PFHead = styled.div`
  display: grid;
  background: ${Colors.darkSteel};
  justify-content: center;
  align-content: center;
  color: #fff;
  height: 50px;
  width: 320px;
`;

const PFBalances = styled.div`
  display: grid;
  grid-template-rows: repeat(auto-fill, 64px);
  grid-gap: 2px;
`;

const PFTotalBg = styled.div`
  padding: 5px;
  background: ${Colors.darkSteel};
`;

const PFTotalItem = styled.div`
  color: #fff;
  padding: 4px;
`;

export { PortfolioPane, PFHead, PFBalances, PFTotalBg, PFTotalItem };



// WEBPACK FOOTER //
// ./src/components/Portfolio/PortfolioBoxUI.tsx